import { LocalizedService } from "../types/Service";

export const getOffsetPositions = (services: LocalizedService[]) => {
    const grouped = new Map<string, typeof services>();

    services.forEach((s) => {
      const key = `${s.latitude},${s.longitude}`;
      if (!grouped.has(key)) grouped.set(key, []);
      grouped.get(key)!.push(s);
    });

    const result = new Map<number, { lat: number; lng: number }>();

    grouped.forEach((group) => {
      group.forEach((service, index) => {
        const offset = 0.00005 * index;
        result.set(service.service_id, {
          lat: service.latitude + offset,
          lng: service.longitude + offset,
        });
      });
    });

  return result;
};
